export type ReportSubmitDialogStep = "awaiting" | "warning" | "receipt";

type ReportSubmitDialogStepInput = {
  awaitingEvidenceCount: number;
  missingLessons: number;
};

/**
 * Trinene i indsend-dialogen, i rækkefølge. Advarslen om dokumentation, der afventer
 * behandling, kommer først: er der noget, advokaten bør vente på, er det lige meget,
 * hvor mange lektioner der mangler lige nu.
 */
export const getReportSubmitDialogSteps = ({
  awaitingEvidenceCount,
  missingLessons,
}: ReportSubmitDialogStepInput): ReportSubmitDialogStep[] => [
  ...(awaitingEvidenceCount > 0 ? (["awaiting"] as const) : []),
  ...(missingLessons > 0 ? (["warning"] as const) : []),
  "receipt",
];

export const getNextReportSubmitDialogStep = (
  steps: ReportSubmitDialogStep[],
  current: ReportSubmitDialogStep,
): ReportSubmitDialogStep => steps[steps.indexOf(current) + 1] ?? "receipt";
